import type { Data } from '@strapi/types';

import { useSharedDocumentsApi } from '@/modules/shared-document/hooks/use-shared-documents-api';
import { useNavigation } from '@/modules/utils/custom-hooks/use-navigation';

import { useOpenDocument } from './use-open-document';

export const useOpenSharedDocument = ({
  accessLevel,
  projectDocumentId
}: {
  projectDocumentId: Data.Entity<'api::project-document.project-document'>['documentId'];
  accessLevel?: Data.Entity<'api::document-access.document-access'>['accessLevel'];
}) => {
  const openDocument = useOpenDocument();
  const { addSearchParam } = useNavigation();
  const { getLastEditorNameBySession } = useSharedDocumentsApi(projectDocumentId);

  const openSharedDocument = ({
    documentTypeName,
    documentId,
    region
  }: {
    documentTypeName: Data.Entity<'api::document-type.document-type'>['title'];
    documentId: Data.Entity<'api::project-document.project-document'>['documentId'];
    region?: Data.Entity<'api::project-document.project-document'>['region'];
  }) => {
    if (accessLevel === 'view') {
      return openDocument({
        documentId,
        documentTypeName,
        accessLevel
      });
    }

    getLastEditorNameBySession.mutateAsync({ documentId }).then((response) => {
      if (response.data) {
        return addSearchParam([
          { key: 'modal', value: 'Alert' },
          { key: 'id', value: documentId },
          { key: 'type', value: 'projectIsLocked' },
          { key: 'userName', value: response.data },
          { key: 'documentType', value: documentTypeName ?? '' }
        ]);
      }

      openDocument({
        documentId,
        documentTypeName,
        accessLevel,
        region
      });
    });
  };

  return {
    openSharedDocument
  };
};
